var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAdjustbalance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47684",
    "data-name": "Path 47684",
    d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0ZM8,14.4a6.69,6.69,0,0,1-4.56-1.84l9.12-9.12A6.69,6.69,0,0,1,14.4,8,6.419,6.419,0,0,1,8,14.4Z",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAdjustbalance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_adjustbalance.e86e5e9a76c399e4b37fcc93d5ce6c74.svg";